import LineDataset from '@fusioncharts/charts/src/dataset/line';
import {
  pluck,
  pluckNumber,
  toRaphaelColor,
  getDashStyle,
  hasTouch,
  TOUCH_THRESHOLD_PIXELS,
  CLICK_THRESHOLD_PIXELS,
  stubFN,
  fcEach,
  BLANKSTRING,
  polyPathToPath
} from '@fusioncharts/core/src/lib';
import { addDep } from '@fusioncharts/core/src/dependency-manager';
import kagiAnimation from './index.animation';
let POSITION_TOP = 'top',
  POSITION_BOTTOM = 'bottom',
  POSITION_MIDDLE = 'middle',
  POSITION_RIGHT = 'right',
  ROUND = 'round',
  UNDEF,
  EVENTARGS = 'eventArgs',
  SETROLLOVERATTR = 'setRolloverAttr',
  SETROLLOUTATTR = 'setRolloutAttr',
  defined = function (obj) {
    return obj !== UNDEF && obj !== null;
  },
  M = 'M',
  H = 'H',
  V = 'V',
  GUTTER_4 = 4,
  GUTTER_2 = 2,
  CENTER = 'center',
  HTP = hasTouch ? TOUCH_THRESHOLD_PIXELS
    : CLICK_THRESHOLD_PIXELS,
  NONE = 'none';
addDep({
  name: 'kagiAnimation',
  type: 'animationRule',
  extension: kagiAnimation
});
class KagiDataset extends LineDataset {
  constructor () {
    super();
    this.manageSpace = stubFN;
    this.drawCommonElements = stubFN;
  }
  /**
   * Sets the type of the component
   * @return {string} type
   */
  getType () {
    return 'dataset';
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'kagi';
  }
  _parseShadowOptions () {
    var dataSet = this,
      chartAttr = dataSet.getFromEnv('chart').getFromEnv('dataSource').chart; // eslint-disable-line good-practices/no-single-usage-variable
    return {
      opacity: pluckNumber(chartAttr.showshadow, 1) ? dataSet.config.alpha / 100 : 0
    };
  }
  configureAttributes (datasetJSON) {
    super.configureAttributes(datasetJSON);
    var dataSetComponents,
      datasetObj = this,
      removeDataArr,
      chart = datasetObj.getFromEnv('chart'), // eslint-disable-line good-practices/no-single-usage-variable
      temp = 0,
      data,
      catArr = [],
      series,
      JSONData,
      FCChartObj,
      isRallyInitialised,
      shiftCounter,
      reversalValue,
      reversalPercentage,
      rallyDashLen,
      rallyDashGap,
      declineDashLen,
      declineDashGap,
      lastPlotValue,
      setShowLabel,
      length,
      index,
      fcIndex,
      fcDataObj,
      lastShift,
      prevDataObj,
      plotValue,
      dataObj,
      nextDataValue,
      valueDifference,
      dataValue,
      isRally,
      lastLow,
      lastHigh,
      isMovingUp,
      isShift,
      checkValue,
      t,
      count = 0,
      vAlign,
      // canvasPadding,
      align;

    dataSetComponents = datasetObj.components;
    data = dataSetComponents.data;
    series = datasetObj.config;
    JSONData = datasetObj.config.JSONData.data;
    FCChartObj = chart.getFromEnv('dataSource').chart;
    removeDataArr = dataSetComponents.removeDataArr || (dataSetComponents.removeDataArr = []); // eslint-disable-line good-practices/no-single-usage-variable
    // First vertical point for shift is yet to be obtained
    isRallyInitialised = false;
    // Initialised to one to avoid zero dividing the width of the canvas
    // (as the case may be) to get the xShiftLength
    shiftCounter = 0; // eslint-disable-line good-practices/no-single-usage-variable
    // The value which determines whether to make a horizontal shift
    // to deal with the next point
    reversalValue = pluckNumber(FCChartObj.reversalvalue, -1);
    // The percentage of the range of values, which determines whether
    // to make a horizontal shift to deal with the next point
    reversalPercentage = pluckNumber(FCChartObj.reversalpercentage, 5); // eslint-disable-line good-practices/no-single-usage-variable

    for (index = 0; index < data.length; index += 1) {
      data[index].config.__nullCount = count;
      if (data[index].config.setValue === null) {
        removeDataArr.push(data.splice(index, 1)[0]);
        count++;
        index -= 1;
      }
    }
    if (data.length) {
      // Color of line denoting rally
      series.rallyColor = pluck(FCChartObj.rallycolor, 'FF0000');
      series.rallyAlpha = pluckNumber(FCChartObj.rallyalpha,
        FCChartObj.linealpha, 100);
      // color of line denoting decline
      series.declineColor = pluck(FCChartObj.declinecolor, '0000FF');
      series.declineAlpha = pluckNumber(FCChartObj.declinealpha,
        FCChartObj.linealpha, 100);
      // Default canvasPadding is 15.
      series.canvasPadding = pluckNumber(FCChartObj.canvaspadding, 15);
      // The maximum horizontal shift in percentage of the
      // available canvas width
      series.maxHShiftPercent = pluckNumber(FCChartObj.maxhshiftpercent, 10);
      // effectiveCanvasWidth = canvasWidth - canvasPadding * 2;
      // Thickness of line denoting rally
      series.rallyThickness = pluckNumber(FCChartObj.rallythickness,
        FCChartObj.linethickness, 2);
      // length of the dash
      rallyDashLen = pluckNumber(FCChartObj.rallydashlen,
        FCChartObj.linedashlen, 5);
      // distance between dash
      rallyDashGap = pluckNumber(FCChartObj.rallydashgap,
        FCChartObj.linedashgap, 4);

      // Thickness of line denoting decline
      series.declineThickness = pluckNumber(FCChartObj.declinethickness,
        FCChartObj.linethickness, 2);
      // length of the dash
      declineDashLen = pluckNumber(FCChartObj.declinedashlen,
        FCChartObj.linedashlen, 5);
      // distance between dash
      declineDashGap = pluckNumber(FCChartObj.declinedashgap,
        FCChartObj.linedashgap, 4);

      series.lineDashed = {
        'true': pluckNumber(FCChartObj.rallydashed,
          FCChartObj.linedashed, 0),
        'false': pluckNumber(FCChartObj.declinedashed,
          FCChartObj.linedashed, 0)
      };

      // Storing dashStyle in series to be use while drawing graph and
      series.rallyDashed = pluckNumber(FCChartObj.rallydashed,
        FCChartObj.linedashed, 0) ? getDashStyle(rallyDashLen, rallyDashGap) : NONE;
      series.declineDashed = pluckNumber(FCChartObj.declinedashed,
        FCChartObj.linedashed, 0) ? getDashStyle(declineDashLen, declineDashGap) : NONE;

      // canvasPadding to be use by Kagi chart Drawing
      series.canvasPadding = pluckNumber(FCChartObj.canvaspadding,
        this.canvasPadding, 15);

      // setting the reversal value
      reversalValue = (reversalValue > 0)
        ? reversalValue : reversalPercentage * (series.maxValue - series.minValue) / 100;

      // Initialised by the first data value
      lastPlotValue = data[0].config.setValue;
      // Local function to set anchor and value visibility of
      // unwanted points, after the first point is found to draw
      // vertical kagi line
      setShowLabel = function (id, _isRally) {
        // Initial data value
        var dataXValue, r = 1,
          data1Value = data[0].config.setValue;
        // Looping to check for unwanted points
        while (r < id) {
          // Value of point under check
          dataXValue = data[r].config.setValue;
          // If current trend is rally
          if (_isRally) {
            if (dataXValue <= data1Value) {
              data[r].config.isDefined = false;
            }
            // Else current trend is decline
          } else {
            if (dataXValue >= data1Value) {
              data[r].config.isDefined = false;
            }
          }
          r += 1;
        }
        // Setting alignment of value for the first data
        data[0].config.vAlign = (_isRally) ? POSITION_BOTTOM
          : POSITION_TOP;
        data[0].config.align = CENTER;
      };

      length = JSONData.length;
      // iterating to set values of properties in data for each respective
      // point (main algorithm of KagiChart)
      // loop counter starts from 2 since data for plot 1 is unique
      for (index = 0, fcIndex = 0; fcIndex < length; fcIndex += 1, index += 1) {
        fcDataObj = JSONData[fcIndex];
        // Calculation of vLine based on hShift.
        if (fcDataObj && fcDataObj.vline) {
          continue;
        }
        dataObj = data[index] && data[index].config;
        // lastFcDataObj = JSONData[fcIndex];
        // Special handling for vLines
        if (lastShift) {
          lastShift = false;
          // vLinePosition += 0.5;
        }
        dataObj && (dataObj.isDefined = true);
        if (index && dataObj) {
          dataObj.isShift = UNDEF;

          prevDataObj = data[index - 1].config;
          dataObj.vAlign = POSITION_MIDDLE;
          dataObj.align = POSITION_RIGHT;
          dataObj.showLabel = false;
          // initialised to null each time
          plotValue = null;
          // data value of plot under current loop
          dataValue = dataObj.setValue;
          // data value of previous plot
          // lastDataValue = data[i-1].y;
          // data value of next plot
          nextDataValue = data[index + 1] && data[index + 1].config.setValue;
          valueDifference = Math.abs(lastPlotValue - dataValue);

          // if current plot is yet render the trend,then care is taken
          // to make few initial assumptions as algorithm starts with it
          if (!isRallyInitialised) {
            // if current plot is higher than the last plotted one
            // (first data) by significant amount
            if (dataValue > lastPlotValue && valueDifference > reversalValue) {
              // is assumed to be true
              isRally = true;
              // value of last low point of swing (assumed)
              lastLow = lastPlotValue;
              // none assumed
              lastHigh = null;
              // kagi rising
              isMovingUp = true;
              // first vertical point for shift is obtained
              isRallyInitialised = true;
              // call of local function to set visibility false for
              // anchors and values of unwanted points
              setShowLabel(index, isRally);
              // if current plot is lower than the last plotted one
              // (first data) by significant amount
            } else if (dataValue < lastPlotValue && valueDifference > reversalValue) {
              // is assumed to be false
              isRally = false;
              // none assumed
              lastLow = null;
              // value of last high point of swing (assumed)
              lastHigh = lastPlotValue;
              // kagi falling
              isMovingUp = false;
              // first vertical point for shift is obtained
              isRallyInitialised = true;
              // call of local function to set visibility false for
              // anchors and values of unwanted points
              setShowLabel(index, isRally);
              // else, point under loop is not significant to
              // draw the first vertical kagi line to
            } else {
              // is set to null
              isRally = null;
              // vertical shifting direction is set to null
              isMovingUp = null;
              // first vertical point for shift is yet to be obtained
              isRallyInitialised = false;
            }
            // trend property for plot 1 is set
            if (defined(prevDataObj)) {
              prevDataObj.isRally = isRally;
            }
            if (isRally !== null) {
              // to get the initial horizontal line in trend color
              // (in case data[1].value = data[2].value=... so on or not)
              data[0].config.isRally = isRally;
            }
            // else, for plot 3 and above, only trend is evaluated
          } else {
            // setting trends by concept of Kagi Chart
            if (dataValue < lastLow && isRally) {
              isRally = false;
            } else if (dataValue > lastHigh && !isRally) {
              isRally = true;
            }
            // else isRally remains unchanged
          }

          // Setting in data for the plot
          dataObj.isRally = isRally;
          // To check for having horizontal shift or not,
          // we need to use the pertinent value
          if ((isMovingUp && dataValue < lastPlotValue) ||
                            (!isMovingUp && dataValue > lastPlotValue)) {
            plotValue = lastPlotValue;
          }
          // To find if there is a horizontal shift associated
          // with this plot
          checkValue = (plotValue) || dataValue;
          valueDifference = Math.abs(checkValue - nextDataValue);
          // if the line is static till now
          if (isMovingUp === null) {
            isShift = null;
            // if the line is rising
          } else if (isMovingUp) {
            isShift = (checkValue > nextDataValue && valueDifference >= reversalValue);
            // else if the line is falling
          } else {
            isShift = (checkValue < nextDataValue && valueDifference >= reversalValue);
          }

          // To get the last extremes preceding the current point
          // and setting the vertical/horizontal
          // alignment of the value to be shown for it.
          if (prevDataObj && prevDataObj.isShift) {
            if (isMovingUp) {
              lastLow = lastPlotValue;
              vAlign = POSITION_BOTTOM;
            } else if (!isMovingUp) {
              lastHigh = lastPlotValue;
              vAlign = POSITION_TOP;
            }
            align = CENTER;
            // looping to get the actual plot corresponding to the
            // maxima/minima and setting label properties for the same
            for (t = index; t > 1; t -= 1) {
              if (data[t].y === lastPlotValue) {
                data[t].vAlign = vAlign;
                data[t].align = align;
                data[t].showLabel = true;
                // extreme obtained and thus stop looping
                break;
              }
            }
          }
          // if there is a horizontal shift, then
          if (isShift) {
            // updating counter to have to total number of horizontal
            // shifts in the total plot.This is vital for calculation
            // of the length of each horizontal shifts.
            shiftCounter += 1;
            // vLinePosition += 0.5;
            lastShift = true;
            // updating the flag by reversing the boolean
            // value of the flag itself
            isMovingUp = !isMovingUp;
            // setting in data for the plot, to be used for
            // drawing the graph
            dataObj.isShift = true;
            // updating last plotting value
            lastPlotValue = checkValue;
            catArr.push(JSONData[index + dataObj.__nullCount]);
            temp = datasetObj._appendCategory(temp, index, catArr, 0);
          } else if ((isMovingUp && dataValue > lastPlotValue) ||
                            (!isMovingUp && dataValue < lastPlotValue)) {
            // updating last plotting value
            lastPlotValue = dataValue;
            // if cuurent data value is to be skipped for plotting
          } else {
            // setting the value to be plotted
            // (virtually drawing pen stays still due to this)
            plotValue = lastPlotValue;
          }
          // plotValue assigned is either defined or set to null
          dataObj.plotValue = plotValue;
          // few local variables are bundled together in an object to be
          // used later-on to work around a Catch-22 problem
          dataObj.objParams = {
            isRally: isRally,
            lastHigh: lastHigh,
            lastLow: lastLow,
            isRallyInitialised: isRallyInitialised
          };
        }
      }
      // insert if any remaining categories to be appended.
      datasetObj._appendCategory(temp, index, catArr, 1);
      // insert the categories before setting the final category.
      catArr.push(fcDataObj);
      datasetObj.getFromEnv('xAxis').setTickValues(catArr);
      series.shiftCount = shiftCounter + 1;
    }
  }
  _appendCategory (tempData, index, catArr, lineposition) {
    var i,
      catObj,
      temp = tempData,
      catData,
      refIndex,
      catOnlyData = this.config.JSONData.catData;
    if (temp < catOnlyData.length) {
      for (i = temp; i < catOnlyData.length; i += 1, temp = i) {
        catObj = catOnlyData[i];
        catData = catObj.data;
        refIndex = catObj.index - (i + 1);
        if (refIndex < index) {
          catData.lineposition = pluckNumber(catData.lineposition, lineposition);
        } else if (refIndex > index) {
          break;
        }
        catArr.push(catData);
      }
    }
    return temp;
  }
  _getHoveredPlot (chartXVal, chartYVal) {
    var dataset = this,
      chartX = chartXVal,
      chartY = chartYVal,
      xAxis = dataset.getFromEnv('xAxis'),
      conf = dataset.config,
      trackIndex = conf.trackIndex, // eslint-disable-line good-practices/no-single-usage-variable
      dataStore = dataset.components.data,
      len = dataStore.length,
      i,
      j,
      index,
      returnValue,
      xMin,
      xMax,
      pointObjs;

    // getting new chart XY accordint to Translation of axis
    chartX += xAxis.getTranslation();

    xMin = Math.floor(Math.max(xAxis.getValue(chartX - conf.maxRadius), 0)); // eslint-disable-line good-practices/no-single-usage-variable
    xMax = Math.ceil(Math.min(xAxis.getValue(chartX + conf.maxRadius), len - 1)); // eslint-disable-line good-practices/no-single-usage-variable

    for (j = xMax; j >= xMin; j--) {
      pointObjs = trackIndex[j];
      len = pointObjs && pointObjs.length;
      // search point objects under current value
      for (i = len; i >= 0; i--) {
        index = pointObjs[i];
        returnValue = dataset.isWithinShape(dataStore[index], index, chartX, chartY);
        if (returnValue) {
          return returnValue;
        }
      }
    }
  }

  /**
   * Returns the clip path for kagi
   *
   * @param {any} type type of clip-rect
   * @memberof KagiDataset
   */
  getClip (type) {
    let canvasConfig = this.getFromEnv('chart').getChildren('canvas')[0].config,
      clipRect = [
        canvasConfig.canvasLeft,
        canvasConfig.canvasTop,
        0,
        canvasConfig.canvasTop + canvasConfig.canvasHeight
      ];

    clipRect[2] += type === 'init' ? 0 : canvasConfig.canvasLeft + canvasConfig.canvasWidth;
    return clipRect;
  }

  /**
   * Parses the plot attributes
   *
   * @param {any} pointData
   * @param {any} index
   * @memberof KagiDataset
   */
  parsePlotAttributes (pointData, index) {
    let i = index,
      point = pointData,
      trackerConfig,
      dataSet = this,
      xPos,
      yPos,
      eventArgs,
      dataObj,
      setRolloutAttr,
      setRolloverAttr,
      anchorRadius,
      hoverEffects,
      anchorProps = {},
      symbol,
      config,
      visible = dataSet.getState('visible'),
      attr;

    point = point.config;
    dataObj = dataSet.components.data[i];
    config = dataObj.config;
    trackerConfig = point.trackerConfig = {}; // eslint-disable-line good-practices/no-single-usage-variable
    hoverEffects = config.hoverEffects;
    xPos = (dataObj._xPos = dataSet.getFromEnv('xAxis').getPixel(point.plotX));
    yPos = (dataObj._yPos = point.plotY);

    dataObj._index = point.plotX;
    anchorProps = config.anchorProps;
    symbol = anchorProps.symbol; // eslint-disable-line good-practices/no-single-usage-variable
    point.finalTooltext = point.toolText;

    if (yPos !== UNDEF && !isNaN(yPos) && point.isDefined) {
      // Storing the event arguments
      eventArgs = point.eventArgs = point.eventArgs || {};

      // Storing the event arguments
      Object.assign(eventArgs, {
        index: i,
        link: config.setLink,
        value: config.setValue,
        displayValue: config.displayValue,
        categoryLabel: config.label,
        toolText: point.finalTooltext,
        id: dataSet.config.userID,
        datasetIndex: 0,
        datasetName: dataSet.config.JSONData.seriesname,
        visible,
        color: config.color,
        alpha: config.alpha,
        anchorBgColor: anchorProps.bgColor,
        anchorBgAlpha: anchorProps.anchorBgAlpha,
        anchorAlpha: anchorProps.anchorAlpha,
        anchorBorderColor: anchorProps.borderColor,
        anchorBorderThickness: anchorProps.borderThickness,
        anchorRadius: anchorProps.radius,
        anchorSides: anchorProps.sides,
        anchorStartAngle: anchorProps.startAngle,
        anchorHoverColor: hoverEffects.anchorColor,
        anchorHoverAlpha: hoverEffects.anchorAlpha,
        anchorHoverSides: hoverEffects.anchorSides,
        dashed: config.dashed,
        valuePosition: config.valuePosition
      });

      // Hover consmetics
      setRolloutAttr = setRolloverAttr = {};

      if (anchorProps.imageUrl) {
        config.anchorImageLoaded = false;
      }
      attr = {
        path: polyPathToPath([symbol[1] || 2, xPos, yPos, anchorProps.radius,
          anchorProps.startAngle, 0]),
        fill: toRaphaelColor({
          color: anchorProps.bgColor,
          alpha: anchorProps.bgAlpha
        }),
        stroke: toRaphaelColor({
          color: anchorProps.borderColor,
          alpha: anchorProps.borderAlpha
        }),
        'stroke-width': anchorProps.borderThickness,
        visibility: !anchorProps.radius ? 'hidden' : visible
      };
      anchorRadius = Math.max(anchorProps.radius,
        (hoverEffects && hoverEffects.anchorRadius) || 0, HTP) + anchorProps.borderThickness / 2;

      trackerConfig.trackerRadius = anchorRadius;

      // Parsing cosmectics to be applied when element is hovered on.
      if (hoverEffects.enabled) {
        setRolloverAttr = {
          path: polyPathToPath([hoverEffects.anchorSides || 2,
            xPos, yPos,
            hoverEffects.anchorRadius,
            hoverEffects.startAngle,
            hoverEffects.dip
          ]),
          fill: toRaphaelColor({
            color: hoverEffects.anchorColor,
            alpha: hoverEffects.anchorBgAlpha
          }),
          stroke: toRaphaelColor({
            color: hoverEffects.anchorBorderColor,
            alpha: hoverEffects.anchorBorderAlpha
          }),
          'stroke-width': hoverEffects.anchorBorderThickness
        };
        setRolloutAttr = {
          path: polyPathToPath([anchorProps.sides, xPos, yPos,
            anchorProps.radius, anchorProps.startAngle, 0
          ]),
          fill: toRaphaelColor({
            color: anchorProps.bgColor,
            alpha: anchorProps.bgAlpha
          }),
          stroke: toRaphaelColor({
            color: anchorProps.borderColor,
            alpha: anchorProps.borderAlpha
          }),
          'stroke-width': anchorProps.borderThickness
        };
        // set hover effect on each data set
        hoverEffects.attrs = {
          'hoverEnabled': hoverEffects.enabled,
          'anchorRadius': anchorProps.radius,
          'anchorHoverRadius': hoverEffects.anchorRadius
        };

        hoverEffects.attrs[SETROLLOVERATTR] = setRolloverAttr;
        hoverEffects.attrs[SETROLLOUTATTR] = setRolloutAttr;

        anchorProps.isAnchorHoverRadius = hoverEffects.attrs.anchorRadius;
      }
    }

    point.props = {
      element: {
        attr: attr
      }
    };
  }

  /**
   * Parses label attributes and position
   *
   * @param {any} dataObj
   * @param {any} index
   * @memberof KagiDataset
   */
  parseLabelAttributes (dataObj, index) {
    var dataSet = this,
      chart = dataSet.getFromEnv('chart'),
      chartConfig = chart.config,
      style = chart.config.dataLabelStyle,
      displayValue = BLANKSTRING,
      rotateValues = chartConfig.rotatevalues ? 270 : 0,
      canvasTop = chartConfig.canvasTop,
      canvasHeight = chartConfig.canvasHeight, // eslint-disable-line good-practices/no-single-usage-variable
      canvasBottom = canvasTop + canvasHeight,
      valuePadding,
      bBoxObj,
      graphic,
      textHeight,
      origTextHeight,
      textY,
      textX,
      yAdjust,
      nextPoint = {}, // eslint-disable-line good-practices/no-single-usage-variable
      prevPoint = {},
      config,
      decidingDimention,
      xPos,
      yPos,
      value,
      anchorRadius,
      i = index,
      plotLabelStyle,
      len = dataSet.components.data.length, // eslint-disable-line good-practices/no-single-usage-variable
      setValue,
      attr;

    config = dataObj && dataObj.config;
    setValue = config && config.setValue;

    if (dataObj === UNDEF || setValue === UNDEF || setValue === null || config.labelSkip === true) {
      config && (delete config.labelSkip);
      return;
    }

    if (index > 0) {
      prevPoint = {
        x: dataSet.components.data[i - 1]._xPos,
        y: dataSet.components.data[i - 1]._yPos
      };
    }

    if (index < len - 1) {
      nextPoint = {
        x: dataSet.components.data[i + 1]._xPos,
        y: dataSet.components.data[i + 1]._yPos
      };
    }

    graphic = dataObj.graphics;
    yPos = dataObj._yPos || dataObj.config._Py;
    xPos = dataObj._xPos || dataObj.config._Px; // eslint-disable-line good-practices/no-single-usage-variable
    anchorRadius = graphic.element ? (graphic.image && // eslint-disable-line good-practices/no-single-usage-variable
                  graphic.element.attr('height') * 0.5) || config.anchorProps.radius - 3 : 0;

    valuePadding = config.valuePadding + GUTTER_2 + anchorRadius;

    displayValue = config.displayValue;
    // Drawing label only if displayvalue is defined and not blank and setValue is not null
    if (defined(displayValue) && displayValue !== '' && value !== null && config.showValue) {
      plotLabelStyle = config.dataLabelStyle;
      attr = {
        text: displayValue,
        fill: plotLabelStyle.color,
        'text-bound': [plotLabelStyle.backgroundColor, plotLabelStyle.borderColor,
          style.borderThickness, style.borderPadding,
          style.borderRadius, style.borderDash
        ]
      };

      bBoxObj = dataSet.getFromEnv('smartLabel').getOriSize(displayValue);

      if (rotateValues) {
        // If rotated values we use the width of
        // the text as height

        config._state = {
          // If label is already rotated then we take the width as labelWidth
          labelWidth: bBoxObj.height,
          labelHeight: bBoxObj.width
        };
        config._rotated = true;
      } else {
        config._state = {
          // If label is already rotated then we take the height as labelWidth
          labelWidth: bBoxObj.width,
          labelHeight: bBoxObj.height
        };
        config._rotated = false;
      }

      // Calculating the total text height
      textHeight = origTextHeight = (rotateValues ? bBoxObj.width
        : bBoxObj.height);
      textHeight += valuePadding;
      yAdjust = (origTextHeight * 0.5) + valuePadding;
      textY = yPos;
      textX = xPos;
      textHeight = textHeight + GUTTER_4;
      decidingDimention = Number(rotateValues) >= 1 ? bBoxObj.height : bBoxObj.width;
      config._valueBelowPoint = 0;

      // Positioning of data labels
      if (nextPoint.y > textY) {
        // nextPoint is below than current point
        if (prevPoint.y < textY) {
          // place aside anchor if not enough space is available in bottom
          textX -= (valuePadding + 3 + decidingDimention * 0.5);
        } else {
          // previous point is below current point
          if (yPos - textHeight < canvasTop) {
            // place aside anchor if not enough space is available on top
            textX -= (valuePadding + 3 + decidingDimention * 0.5);
            textY = canvasTop + textHeight / 2;
          } else {
            // else place vertically above anchor
            textY -= yAdjust;
          }
        }
      } else {
        // nextpoint is above the current point
        if (prevPoint.y > textY) {
          // place aside anchor if not enough space is available in bottom
          textX -= (valuePadding + 3 + decidingDimention * 0.5);
        } else {
          // previous point is above current point
          if (yPos + textHeight > canvasBottom) {
            // place aside anchor if not enough space is available in bottom
            textX -= (valuePadding + 3 + decidingDimention * 0.5);
            textY = canvasBottom - textHeight / 2;
          } else {
            // else place vertically below anchor
            textY += yAdjust + GUTTER_2;
            config._valueBelowPoint = 1;
          }
        }
      }

      attr.x = textX;
      attr.y = textY;
    }

    config.props = config.props || {};
    config.props.label = {
      attr: attr
    };
  }
  /**
   * Parses anchor position and cosmetics during post space management
   *
   * @returns {any}
   * @memberof KagiDataset
   */
  allocatePosition () {
    let i,
      dataSet = this,
      conf = dataSet.config,
      setDataArr = dataSet.components.data,
      dataSetLen = setDataArr && setDataArr.length, // eslint-disable-line good-practices/no-single-usage-variable
      xAxis = dataSet.getFromEnv('xAxis'),
      setValue,
      dataStore = dataSet.components.data,
      dataObj,
      xAxisZeroPos = xAxis.getPixel(0),
      xAxisFirstPos = xAxis.getPixel(1), // eslint-disable-line good-practices/no-single-usage-variable
      pointDistance = xAxisFirstPos - xAxisZeroPos,
      thickness = {
        'true': conf.rallyThickness,
        'false': conf.declineThickness
      },
      rallyPath,
      declinePath,
      xValue = 0, // eslint-disable-line good-practices/no-single-usage-variable
      plotX = xAxis.getPixel(xValue),
      isRally = setDataArr[0] && !!setDataArr[0].isRally,
      nextPointIsRally,
      startX = xAxisZeroPos - (pointDistance / 2),
      plotY,
      crispY,
      nextPoint,
      path;

    conf.imagesLoaded = 0;
    if (!setDataArr.length) {
      return;
    }

    rallyPath = conf.rallyPath = [];
    declinePath = conf.declinePath = [];
    // Set components.data to blank array if dataStore is not present
    dataStore = dataSet.components.data = dataStore || [];

    // Special situation for first null data.
    if (!setDataArr[0].config.setValue) {
      for (i = 1; i < dataSetLen; i += 1) {
        setValue = setDataArr[i].config.setValue;
        if (setValue) {
          // Get the first valid value.
          plotY = setDataArr[i].config.plotY;
          break;
        }
      }
    } else {
      plotY = setDataArr[0].config.plotY;
    }
    isRally = !!setDataArr[0].config.isRally;
    // drawing starts with an initial half horizontal-shift
    crispY = Math.round(plotY) + (thickness[isRally] % 2 / 2);
    if (isRally) {
      rallyPath.push(M, startX, crispY, H, plotX);
    } else {
      declinePath.push(M, startX, crispY, H, plotX);
    }

    fcEach(setDataArr, function (pointData, ii) {
      let point = pointData;
      point = point.config;
      dataObj = dataStore[ii];
      setValue = dataObj.config.setValue;
      // looping to draw the plots
      nextPoint = (setDataArr[ii + 1] && setDataArr[ii + 1].config) || {};
      if (nextPoint) {
        path = [M, plotX, plotY];
        isRally = point.isRally;
        // if there is a shift corresponding to this point
        if (point.isShift) {
          plotX += pointDistance;
          plotY = point.graphY;
          path.push(H, plotX);
          path[2] = Math.round(path[2]) +
                            (thickness[isRally] % 2 / 2);
          path = path.toString();
          // draw the path
          if (isRally) {
            rallyPath.push(path);
          } else {
            declinePath.push(path);
          }
          path = [M, plotX, plotY];
        }
        // if there is a change in trend between the current and
        // the next points
        if (nextPoint.isChanged) {
          plotY = nextPoint.ty;
          path.push(V, plotY);
          path[1] = Math.round(path[1]) + (thickness[!!isRally] % 2 / 2);
          path = path.toString();
          if (isRally) {
            rallyPath.push(path);
          } else {
            declinePath.push(path);
          }
          path = [M, plotX, plotY];
        }

        nextPointIsRally = nextPoint.isRally;
        // TODO: If path contains move to and line to at the same point line is not visible in
        //       native VML brewers need to remove this code when this issue in fixed in core.

        if (nextPoint.graphY !== path[2] && nextPoint.graphY !== UNDEF) {
          path.push(V, nextPoint.graphY);
          path[1] = Math.round(path[1]) + (thickness[!!nextPointIsRally] % 2 / 2);
          path = path.toString();
          if (nextPointIsRally) {
            rallyPath.push(path);
          } else {
            declinePath.push(path);
          }
        }
        // updating value
        nextPoint.graphY && (plotY = nextPoint.graphY);
      }
      dataSet.parsePlotAttributes(dataObj, ii);
    });

    for (i = 0; i < setDataArr.length; i++) {
      dataSet.parseLabelAttributes(dataStore[i], i);
    }
  }
  /**
   * Draw the plots of kagi chart
   *
   * @memberof KagiDataset
   */
  drawPlots () {
    let graphics,
      dataSet = this,
      datasetGraphics = dataSet.getGraphicalElement(),
      animationManager = dataSet.getFromEnv('animationManager'),
      conf = dataSet.config,
      // temp hardcoded.
      trackIndex = conf.trackIndex = {},
      setDataArr = dataSet.components.data,
      yPos,
      setElement,
      dataStore = dataSet.components.data, // eslint-disable-line good-practices/no-single-usage-variable
      dataObj,
      hoverEffects,
      shadow = conf.shadow,
      anchorProps = {},
      config,
      rallyThickness = conf.rallyThickness,
      declineThickness = conf.declineThickness,
      rallyAttr = {
        stroke: toRaphaelColor({
          color: conf.rallyColor,
          alpha: conf.rallyAlpha
        }),
        'stroke-linecap': ROUND,
        'stroke-linejoin': ROUND,
        'stroke-width': rallyThickness,
        'stroke-dasharray': conf.rallyDashed
      },
      declineAttr = {
        stroke: toRaphaelColor({
          color: conf.declineColor,
          alpha: conf.declineAlpha
        }),
        'stroke-linecap': ROUND,
        'stroke-linejoin': ROUND,
        'stroke-width': declineThickness,
        'stroke-dasharray': conf.declineDashed
      },
      rallyElemDummy = datasetGraphics.rallyElem,
      rallyElem,
      declineElemDummy = datasetGraphics.declineElem,
      declineElem,
      attr,
      commonElemGroup = dataSet.getContainer('commonElemsGroup'),
      plotGroup = dataSet.getContainer('plotGroup'), // eslint-disable-line good-practices/no-single-usage-variable
      shadowGroup = dataSet.getContainer('shadowGroup'),
      imageElement;

    // save the world if no valid data is there.
    if (!setDataArr.length) {
      rallyElem && rallyElem.hide();
      declineElem && declineElem.hide();
      return;
    }
    rallyElem && rallyElem.show();
    declineElem && declineElem.show();

    fcEach(setDataArr, function (pointData, i) {
      let point = pointData;
      point = point.config;
      dataObj = dataStore[i];
      config = dataObj.config;
      graphics = dataObj.graphics;
      imageElement = graphics.image;
      hoverEffects = config.hoverEffects;
      yPos = dataObj._yPos;

      if (!trackIndex[point.plotX]) {
        trackIndex[point.plotX] = [];
      }
      trackIndex[point.plotX].push(i);
      dataObj._index = point.plotX;
      anchorProps = config.anchorProps;

      if (yPos !== UNDEF && !isNaN(yPos) && point.isDefined) {
        if (anchorProps.imageUrl) {
          dataSet.drawAnchorImage(dataObj);
        } else {
          imageElement && imageElement.hide();
          setElement = graphics.element;
          attr = point.props.element.attr;

          // create/reuse setElement
          setElement = graphics.element = animationManager.setAnimation({
            el: setElement || 'path',
            attr: attr,
            container: plotGroup,
            component: dataSet,
            label: 'anchor'
          });
          // Set properties to the data of element
          setElement.show()
            .shadow(anchorProps.shadow, shadowGroup)
            .data('anchorRadius', anchorProps.radius)
            .data('anchorHoverRadius', hoverEffects.anchorRadius)
            .data('hoverEnabled', hoverEffects.enabled)
            .data(EVENTARGS, point.eventArgs);
        }

        // Parsing cosmectics to be applied when element is hovered on.
        if (hoverEffects.enabled) {
          setElement && setElement
            .data('anchorRadius', anchorProps.radius)
            .data('anchorHoverRadius', hoverEffects.anchorRadius)
            .data('hoverEnabled', hoverEffects.enabled)
            .data(SETROLLOVERATTR, hoverEffects.attrs[SETROLLOVERATTR])
            .data(SETROLLOUTATTR, hoverEffects.attrs[SETROLLOUTATTR])
            .data(EVENTARGS, point.eventArgs);
        }
      } else {
        graphics.element && graphics.element.hide();
        imageElement && imageElement.hide();
      }
    });

    // Create/reuse rally element
    rallyAttr.path = conf.rallyPath;
    rallyElem = animationManager.setAnimation({
      el: rallyElemDummy || 'path',
      attr: rallyAttr,
      container: commonElemGroup,
      component: dataSet,
      label: 'line'
    });
    rallyElem
      .shadow(rallyThickness && shadow, shadowGroup);
    if (!rallyElemDummy) {
      dataSet.addGraphicalElement('rallyElem', rallyElem);
    }

    // create/reuse decline element
    declineAttr.path = conf.declinePath;
    declineElem = animationManager.setAnimation({
      el: declineElemDummy || 'path',
      attr: declineAttr,
      container: commonElemGroup,
      component: dataSet,
      label: 'line'
    });
    declineElem
      .shadow(declineThickness && shadow, shadowGroup);
    if (!declineElemDummy) {
      dataSet.addGraphicalElement('declineElem', declineElem);
    }
  }
}
export default KagiDataset;
